import { render } from "./SupportApp.vue?vue&type=template&id=1e80b1db&scoped=true"
import script from "./SupportApp.vue?vue&type=script&lang=js"
export * from "./SupportApp.vue?vue&type=script&lang=js"

import "./SupportApp.vue?vue&type=style&index=0&id=1e80b1db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e80b1db"]])

export default __exports__